import { SuitePrice } from "@ssc-booking/api-contracts"
import * as F from "fp-ts/function"
import * as O from "fp-ts/Option"
import { t } from "@lingui/macro"
import { Price } from "@silversea-ssc/ui-components-react"
import { formatCurrency } from "../../app-core/_common/format/localization"

export const suitePriceToFormattedPrice = (price: SuitePrice): Price =>
    F.pipe(
        price.originalTotal,
        O.matchW(
            () => ({
                type: "price" as const,
                fareLabel: t`Total price`,
                formattedAmount: formatCurrency(price.total.value, price.total.currency),
            }),
            (originalTotal) => ({
                type: "discounted" as const,
                fareLabel: t`Offer price`,
                formattedAmount: formatCurrency(price.total.value, price.total.currency),
                formattedOriginalAmount: formatCurrency(originalTotal.value, originalTotal.currency),
            }),
        ),
    )
